import axios from '@/lib/axios';
import { FlatRateLensOrderParams } from '../types';

const createFlatRateLens = (data: FlatRateLensOrderParams) => {
  return axios.post('/facility/orders/flat_rate_lens', data);
}

export default createFlatRateLens;